import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconTypographyCase16(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={16}
            height={16}
            className={customClassName}
            name="IconTypographyCase16"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M9 2H7a1 1 0 0 0-1 1v1h4V3a1 1 0 0 0-1-1M5 3v1H3a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2h-2V3a2 2 0 0 0-2-2H7a2 2 0 0 0-2 2m5 2h3a1 1 0 0 1 1 1v6a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1zM5.5 6H5v1.5a.5.5 0 0 0 1 0V7h1.5v4h-1a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1h-1V7H10v.5a.5.5 0 0 0 1 0V6z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconTypographyCase16);
